import { Plus } from 'lucide-react'
import { BasicInput } from '../../../../../components/BasicInput'
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
  AlertDialogTrigger,
} from '../../../../../components/ui/alert-dialog'
import { useAddTableCardController } from './useAddTableCardController'
import { percentageMask } from '@/app/utils/comissionPercentage'
import { useAuth } from '@/app/hooks/useAuth'
import { moneyMask } from '@/app/utils/formatMoneyValue'

export const AddTableCard = () => {
  const { handleAddTable, isPending, methods } = useAddTableCardController()

  const { isSuperAdmin } = useAuth()

  return (
    <div>
      <AlertDialog>
        {isSuperAdmin && (
          <AlertDialogTrigger>
            <div className="flex h-12 w-fit items-center justify-center gap-2 rounded-full bg-primary px-4 text-white">
              <div className="flex h-5 w-5 items-center justify-center rounded-full bg-white">
                <Plus size={14} className="text-primary" />
              </div>

              <p className="font-semibold">Adicionar tabela</p>
            </div>
          </AlertDialogTrigger>
        )}

        <AlertDialogContent className="w-full max-w-[470px] p-0">
          <form onSubmit={methods.handleSubmit(handleAddTable)}>
            <AlertDialogHeader className="flex flex-col gap-4 p-5">
              <AlertDialogTitle>Adicionar tabela</AlertDialogTitle>

              <div className="border-b-[1px] border-gray01" />
            </AlertDialogHeader>

            <div className="flex w-full flex-col items-center gap-5 p-5">
              <BasicInput
                label="ID"
                name="tableCode"
                placeholder="Escreva o ID da tabela"
                style={{ backgroundColor: '#F7F7F7' }}
                error={methods.formState.errors.tableCode?.message}
              />

              <BasicInput
                label="Nome"
                name="name"
                placeholder="Escreva o nome da tabela"
                style={{ backgroundColor: '#F7F7F7' }}
                error={methods.formState.errors.name?.message}
              />

              <div className="flex gap-4">
                <BasicInput
                  label="Comissão"
                  name="percents"
                  placeholder="0,00"
                  style={{ backgroundColor: '#F7F7F7' }}
                  error={methods.formState.errors.percents?.message}
                  variant="percentage"
                  onInput={percentageMask}
                />

                <BasicInput
                  label="Bônus"
                  name="bonus"
                  placeholder="0,00"
                  style={{ backgroundColor: '#F7F7F7' }}
                  error={methods.formState.errors.bonus?.message}
                  variant="percentage"
                  onInput={percentageMask}
                />
              </div>

              <BasicInput
                label="Comissão Líder"
                name="leaderCommission"
                placeholder="0,00"
                style={{ backgroundColor: '#F7F7F7' }}
                error={methods.formState.errors.leaderCommission?.message}
                variant="percentage"
                onInput={percentageMask}
              />

              <div className="flex gap-4">
                <BasicInput
                  label="Limite de emissão"
                  name="limit"
                  placeholder="R$ 0,00"
                  style={{ backgroundColor: '#F7F7F7' }}
                  error={methods.formState.errors.limit?.message}
                  onInput={moneyMask}
                />
                <BasicInput
                  label="Máximo"
                  name="maxPercents"
                  placeholder="0,00"
                  style={{ backgroundColor: '#F7F7F7' }}
                  error={methods.formState.errors.maxPercents?.message}
                  variant="percentage"
                  onInput={percentageMask}
                />
              </div>
            </div>

            <AlertDialogFooter className="space-x-2 p-5">
              <AlertDialogCancel className="w-full rounded-full bg-white02">
                Cancelar
              </AlertDialogCancel>

              <AlertDialogAction
                disabled={isPending}
                type="submit"
                className="w-full rounded-full bg-primary text-white"
              >
                Adicionar tabela
              </AlertDialogAction>
            </AlertDialogFooter>
          </form>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  )
}
